// Fellowship landing page content configuration
// Each key maps to a specialtyId from specialtyConfig.js

export const FELLOWSHIP_CONTENT = {
  pain: {
    specialtyId: 'pain',
    badge: '#1 Pain Medicine Board Review Platform',
    heroTitle: ['Pass Your ', 'Pain Medicine Boards', ' With Confidence'],
    heroSubtitle:
      'Master Pain Medicine with our comprehensive question bank. Board-style questions with detailed explanations written by Pain Medicine physicians.',
    trustText: '',
    features: [
      {
        icon: 'fas fa-syringe',
        title: 'Interventional Procedures',
        description:
          'Master fluoroscopic and ultrasound-guided interventional pain procedures with detailed question explanations.',
        color: '#f5365c',
      },
      {
        icon: 'fas fa-chart-line',
        title: 'Performance Analytics',
        description:
          'Track your progress with detailed analytics and identify areas for improvement.',
        color: '#5e72e4',
      },
      {
        icon: 'fas fa-clock',
        title: 'Timed Practice Exams',
        description:
          'Simulate real exam conditions with customizable timed practice tests.',
        color: '#fb6340',
      },
      {
        icon: 'fas fa-pills',
        title: 'Pain Pharmacology',
        description:
          'Comprehensive coverage of opioid and non-opioid analgesics, adjuvants, and multimodal pain management.',
        color: '#11cdef',
      },
      {
        icon: 'fas fa-robot',
        title: 'AI Tutor',
        description:
          'Get personalized explanations and guidance powered by AI to help you master each topic.',
        color: '#2dce89',
      },
      {
        icon: 'fas fa-users',
        title: 'Expert Authored',
        description:
          'Questions written and reviewed by Pain Medicine physicians.',
        color: '#ffd600',
      },
    ],
    stats: [
      { number: '500+', label: 'Practice Questions' },
      { number: '50+', label: 'Topics Covered' },
      { number: '10+', label: 'Subject Areas' },
      { number: '24/7', label: 'Access Anywhere' },
    ],
    topics: [
      'Interventional Pain Procedures',
      'Chronic Pain Management',
      'Acute Pain Management',
      'Cancer Pain',
      'Neuropathic Pain',
      'Musculoskeletal Pain',
      'Headache Medicine',
      'Pain Pharmacology',
      'Neuromodulation',
      'Spine Interventions',
      'Joint & Nerve Blocks',
      'Pain Psychology',
    ],
    testimonials: [
      {
        name: 'Pain Medicine Fellow',
        role: 'Pain Fellow',
        text: 'The Pain Medicine question bank covers exactly what you need for boards. The interventional procedure questions are particularly strong and mirror real exam content.',
        avatar: 'PF',
      },
      {
        name: 'Pain Medicine Fellow',
        role: 'Pain Fellow',
        text: 'Excellent resource for Pain Medicine board prep. The detailed explanations for pharmacology and interventional questions really helped solidify my understanding.',
        avatar: 'PF',
      },
      {
        name: 'Pain Medicine Fellow',
        role: 'Pain Fellow',
        text: 'I used this alongside other resources and found the question quality to be outstanding. The AI tutor feature was a game-changer for understanding complex pain pathways.',
        avatar: 'PF',
      },
    ],
    groupCard: {
      subtitle: 'Tailored for Pain Medicine fellowship programs',
      badgeText: 'FOR FELLOWSHIP PROGRAMS',
      title: 'Fellowship Program Plan',
      features: [
        'Full Question Bank access',
        'Detailed explanations',
        'Unique redemption codes',
        'Priority email support',
      ],
    },
    ctaTitle: 'Ready to Pass Your Pain Medicine Boards?',
    ctaSubtitle:
      'Start preparing for your Pain Medicine boards with confidence. Start your 14-day free trial today — you won\'t be charged until it ends.',
    footerDescription:
      'The most comprehensive Pain Medicine board review question bank.',
    seo: {
      title: 'Pain Medicine Prep | #1 Pain Medicine Board Review Question Bank',
      description:
        'Pass your Pain Medicine boards with confidence. Board-style questions, detailed explanations, and performance analytics.',
      keywords:
        'pain medicine board review, pain medicine question bank, pain boards prep, interventional pain exam, ABPM board review, pain medicine practice questions',
      url: 'https://pmrprep.io/fellowship/pain-medicine',
    },
    colors: {
      primary: '#172b4d',
      secondary: '#f5365c',
      gradient: 'linear-gradient(135deg, #172b4d 0%, #1a365d 50%, #f5365c 100%)',
      gradientLight: 'linear-gradient(135deg, #f5365c 0%, #ff6b6b 100%)',
      navGradient: 'linear-gradient(135deg, #f5365c 0%, #d32f4f 100%)',
      navScrolled: 'linear-gradient(135deg, #d32f4f 0%, #b8283f 100%)',
      ctaGradient: 'linear-gradient(135deg, #f5365c 0%, #ff6b6b 100%)',
      textGradientLight: 'linear-gradient(135deg, #f5365c 0%, #ffffff 100%)',
      btnShadow: 'rgba(245, 54, 92, 0.3)',
      btnShadowHover: 'rgba(245, 54, 92, 0.4)',
      stepShadow: 'rgba(245, 54, 92, 0.3)',
    },
  },
  sports: {
    specialtyId: 'sports',
    badge: '#1 Sports Medicine Board Review Platform',
    heroTitle: ['Pass Your ', 'Sports Medicine Boards', ' With Confidence'],
    heroSubtitle:
      'Master Sports Medicine with our comprehensive question bank. Board-style questions with detailed explanations written by Sports Medicine physicians.',
    trustText: '',
    features: [
      {
        icon: 'fas fa-running',
        title: 'MSK Injuries & Rehabilitation',
        description:
          'Comprehensive coverage of musculoskeletal injuries, rehabilitation protocols, and return-to-play decisions.',
        color: '#11cdef',
      },
      {
        icon: 'fas fa-chart-line',
        title: 'Performance Analytics',
        description:
          'Track your progress with detailed analytics and identify areas for improvement.',
        color: '#5e72e4',
      },
      {
        icon: 'fas fa-clock',
        title: 'Timed Practice Exams',
        description:
          'Simulate real exam conditions with customizable timed practice tests.',
        color: '#fb6340',
      },
      {
        icon: 'fas fa-x-ray',
        title: 'MSK Ultrasound & Imaging',
        description:
          'Master diagnostic imaging and ultrasound-guided procedures essential for Sports Medicine practice.',
        color: '#11cdef',
      },
      {
        icon: 'fas fa-robot',
        title: 'AI Tutor',
        description:
          'Get personalized explanations and guidance powered by AI to help you master each topic.',
        color: '#f5365c',
      },
      {
        icon: 'fas fa-users',
        title: 'Expert Authored',
        description:
          'Questions written and reviewed by Sports Medicine physicians.',
        color: '#ffd600',
      },
    ],
    stats: [
      { number: '500+', label: 'Practice Questions' },
      { number: '50+', label: 'Topics Covered' },
      { number: '10+', label: 'Subject Areas' },
      { number: '24/7', label: 'Access Anywhere' },
    ],
    topics: [
      'Musculoskeletal Injuries',
      'Concussion Management',
      'Sports Cardiology',
      'Exercise Physiology',
      'MSK Ultrasound',
      'Shoulder & Elbow',
      'Hip & Knee',
      'Foot & Ankle',
      'Spine in Athletes',
      'Return to Play',
      'Sports Nutrition',
      'Anti-Doping',
    ],
    testimonials: [
      {
        name: 'Sports Medicine Fellow',
        role: 'Sports Fellow',
        text: 'This question bank is an excellent resource for Sports Medicine board prep. The MSK injury and concussion management questions are particularly well-written.',
        avatar: 'SF',
      },
      {
        name: 'Sports Medicine Fellow',
        role: 'Sports Fellow',
        text: 'Great coverage of Sports Medicine topics from shoulder injuries to exercise physiology. The detailed explanations really help with understanding the nuances.',
        avatar: 'SF',
      },
      {
        name: 'Sports Medicine Fellow',
        role: 'Sports Fellow',
        text: 'The AI tutor and performance analytics helped me focus my study time on weak areas. Highly recommend for anyone preparing for Sports Medicine boards.',
        avatar: 'SF',
      },
    ],
    groupCard: {
      subtitle: 'Tailored for Sports Medicine fellowship programs',
      badgeText: 'FOR FELLOWSHIP PROGRAMS',
      title: 'Fellowship Program Plan',
      features: [
        'Full Question Bank access',
        'Detailed explanations',
        'Unique redemption codes',
        'Priority email support',
      ],
    },
    ctaTitle: 'Ready to Pass Your Sports Medicine Boards?',
    ctaSubtitle:
      'Start preparing for your Sports Medicine boards with confidence. Start your 14-day free trial today — you won\'t be charged until it ends.',
    footerDescription:
      'The most comprehensive Sports Medicine board review question bank.',
    seo: {
      title: 'Sports Medicine Prep | #1 Sports Medicine Board Review Question Bank',
      description:
        'Pass your Sports Medicine boards with confidence. Board-style questions, detailed explanations, and performance analytics.',
      keywords:
        'sports medicine board review, sports medicine question bank, sports medicine boards prep, CAQSM exam prep, sports medicine practice questions',
      url: 'https://pmrprep.io/fellowship/sports-medicine',
    },
    colors: {
      primary: '#172b4d',
      secondary: '#11cdef',
      gradient: 'linear-gradient(135deg, #172b4d 0%, #1a365d 50%, #11cdef 100%)',
      gradientLight: 'linear-gradient(135deg, #11cdef 0%, #0da5c7 100%)',
      navGradient: 'linear-gradient(135deg, #11cdef 0%, #0da5c7 100%)',
      navScrolled: 'linear-gradient(135deg, #0da5c7 0%, #0a8ba8 100%)',
      ctaGradient: 'linear-gradient(135deg, #11cdef 0%, #0da5c7 100%)',
      textGradientLight: 'linear-gradient(135deg, #11cdef 0%, #ffffff 100%)',
      btnShadow: 'rgba(17, 205, 239, 0.3)',
      btnShadowHover: 'rgba(17, 205, 239, 0.4)',
      stepShadow: 'rgba(17, 205, 239, 0.3)',
    },
  },
};
